import styled from 'styled-components'

export const ComposerRoot = styled.div`
  height: calc(100vh - 112px);
  max-height: 888px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5em;
  -webkit-font-smoothing: antialiased;
  transition: height 350ms ease-in-out;

  @media (max-width: 768px) {
    height: 100dvh;
    max-height: calc(100dvh - var(--space-4xl));
    width: calc(100dvw - var(--space-3xl));
  }
`

export const App = styled.div<{
  $fullHeight?: boolean
  $sidebarRightVisible?: boolean
  $sidebarLeftVisible?: boolean
}>`
  --composer-padding: var(--space-xl);

  position: relative;
  z-index: 2;
  width: 720px;
  display: flex;
  flex-direction: column;
  /* margin: 100px auto 50px; */
  margin: 0px auto;
  transform: translate(0%, 0%);
  /* added to fix ie11 issue with react-tooltip */
  border: 1px solid transparent;
  border-radius: var(--border-radius-md);
  background: var(--color-bg-surface-floating);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.28);

  padding: 0 var(--composer-padding);
  box-sizing: border-box;

  transition: all 350ms ease-in-out;
  margin-left: ${(props): string =>
    props.$sidebarLeftVisible ? '374px !important' : '0px'};
  margin-right: ${(props): string =>
    props.$sidebarRightVisible ? '374px !important' : '0px'};

  height: ${(props): string => (props.$fullHeight ? '100%' : 'auto')};
  max-height: 100%;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    max-height: 100%;
  }

  @media (max-width: 1124px) {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
`
